"use client"

import { useEffect } from "react"
import { Button } from "@/components/ui/button"

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="text-center space-y-4 max-w-md">
        <h2 className="text-2xl font-bold text-foreground font-[family-name:var(--font-display)]">
          Something went wrong
        </h2>
        <p className="text-muted-foreground">
          We ran into an issue loading this page. Please try again.
        </p>
        <Button onClick={reset} className="bg-accent hover:bg-accent/90 text-accent-foreground">
          Try again
        </Button>
      </div>
    </div>
  )
}
